<template>
  <div
    v-if="item.specialInstructions || item.modifiers.length > 0"
    class="item-list__description-text"
  >
    <p v-if="modifiers.standardModifiers.length > 0">
      <template v-for="modifier in modifiers.standardModifiers">
        <!-- content must be on the same line as open/close tags for proper spacing of pseudo elements -->
        <span
          v-if="modifier.itemDescription"
          :key="modifier.menuItemId"
          class="item-list__tag"
        >{{ modifier.itemDescription }}{{ modifierQuantityDisplay(modifier.quantity) }}</span>
      </template>
    </p>

    <p
      v-for="nestedModifier in modifiers.nestedModifiers"
      :key="nestedModifier.menuItemId"
    >
      <span class="title title--7 no-spacing dark">{{ nestedModifier.itemDescription }}</span>

      <template v-for="modifier in nestedModifier.modifiers">
        <!-- will there be nested modifiers with quantities? -->
        <span
          v-if="modifier.itemDescription"
          :key="modifier.menuItemId"
          class="item-list__tag"
        >{{ modifier.itemDescription }}{{ modifierQuantityDisplay(modifier.quantity) }}</span> <!-- content must be on the same line as open/close tags for proper spacing of pseudo elements -->
      </template>
    </p>

    <p
      v-if="item.specialInstructions"
      class="smaller"
    >
      <i>
        Instructions: {{ item.specialInstructions }}
      </i>
    </p>
  </div>
</template>



<script>
  export default {
    name: 'OrderItemDescriptionText',

    props: {
      item: {
        type: Object,
        required: true
      }
    },

    computed: {
      modifiers() {
        const result = {
          nestedModifiers: [],
          standardModifiers: []
        };

        this.item.modifiers.forEach((modifier) => {
          if (modifier.modifiers && modifier.modifiers.length > 0) {
            result.nestedModifiers.push(modifier);
          }

          else {
            result.standardModifiers.push(modifier);
          }
        });

        return result;
      }
    },

    methods: {
      modifierQuantityDisplay(quantity) {
        return quantity > 1 ? ` (${quantity})` : '';
      }
    }
  };
</script>
